import startCase from 'lodash/startCase';

import { LABELS } from '../literals';

export const getFieldLabel = (key: string) => (LABELS[key] ? LABELS[key] : startCase(key));
